import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c606f982&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c606f982')) {
      api.createRecord('c606f982', component.options)
    } else {
      api.reload('c606f982', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c606f982&", function () {
      api.rerender('c606f982', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/paye/index.vue"
export default component.exports